import { useMemo } from 'react';
import { paths } from 'src/routes/paths';
import SvgColor from 'src/components/svg-color';
import Iconify from 'src/components/iconify';

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  dashboard: icon('ic_dashboard'),
};

export function useNavData() {
  const data = useMemo(() => {
    const items = [
      {
        subheader: 'Overview',
        items: [{ title: 'Dashboard', path: paths.pharmacy_dashboard.root, icon: ICONS.dashboard }],
      },
      {
        subheader: 'Settings',
        items: [
          {
            title: 'Pharmacy Profile',
            path: `${paths.pharmacy_dashboard.root}#profile`,
            icon: ICONS.dashboard,
          },
        ],
      },
    ];

    return items;
  }, []);

  return data;
}

export function useBottomNavData() {
  const data = useMemo(() => {
    const items = [
      { title: 'Home', path: paths.pharmacy_dashboard.root, icon: <Iconify icon="tabler:home" /> },
      {
        title: 'Profile',
        path: `${paths.pharmacy_dashboard.root}#profile`,
        icon: <Iconify icon="tabler:user" />,
      },
    ];

    return items;
  }, []);

  return data;
}
